import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IDriver} from "../../classes/Domain";
import { VALIDATION } from "../../AppConstants";

const rules = {
    firstName: 'required',
    lastName: 'required',
    maritalStatus: 'required'
};

const customErrorMessages = {
    "regex.birthDate": VALIDATION.DATE_FORMAT,
};

export const allFieldsValidation = (data: IDriver, stateCode: string | null = null) => {
    rules["birthDate"] = data.isInsured
        ? ['required', 'regex:/^\\d{2}\\/\\d{2}\\/\\d{4}$/', 'valid_date', 'valid_insured_age']
        : ['required', 'regex:/^\\d{2}\\/\\d{2}\\/\\d{4}$/', 'valid_date', 'valid_driver_age'];

    rules["gender"] = ['required'];

    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};